module.exports = __webpack_public_path__ + "img/Toyota-2019-4Runner-2.e96d4c2a.png";